<input
  (ngModelChange)="onChanges($event)"
  [errorStateMatcher]="errorStateMatcher"
  [formControl]="fControl"
  [formlyAttributes]="field"
  [matAutocomplete]="auto"
  [placeholder]="to.placeholder || ''"
  matInput
/>
<mat-autocomplete
  #auto="matAutocomplete"
  [autoActiveFirstOption]="true"
  [displayWith]="displayFn.bind(this)"
>
  <mat-option
    *ngFor="let value of filteredOptions | async"
    [value]="value[to.valueProp]"
  >
    {{ value[to.labelProp] }}
  </mat-option>
</mat-autocomplete>
